// extracted by mini-css-extract-plugin
export default {"LastKeyGiverDropsList":"LastKeyGiverDropsList_LastKeyGiverDropsList__momMa","select":"LastKeyGiverDropsList_select__8u3Wx"};